import { render } from "./CookieConsentApp.vue?vue&type=template&id=a832ca20"
import script from "./CookieConsentApp.vue?vue&type=script&lang=js"
export * from "./CookieConsentApp.vue?vue&type=script&lang=js"

import exportComponent from "/builds/westartdev/projects/liberalerna/riks-web/wp-content/themes/liberalerna/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__